import { useClipboard } from '@calendly/clipboard';
import { CheckboxField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { CheckIcon, CopyIcon } from '@calendly/ui/components/icons';
import { ProTip } from '@calendly/ui/components/pro-tip';
import classNames from 'classnames';
import { useContext, forwardRef } from 'react';
import { ShareContext } from '../context';
const checkboxContainerCss = "cgjx9mm";
const CheckboxContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(checkboxContainerCss, props.className)} />;
});
const passcodeContainerCss = "p1va8fvy";
const PasscodeContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(passcodeContainerCss, props.className)} />;
});
const spanCss = "s1byowqd";
const Span = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(spanCss, props.className)} />;
});
const flexContainerBlueCss = "f1od43rs";
const FlexContainerBlue = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(flexContainerBlueCss, props.className)} />;
});
const indentedSpanCss = "i18ona51";
const IndentedSpan = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(indentedSpanCss, props.className)} />;
});
const CopyButton = ({
  passcode
}) => {
  const [Wrapper, ref, isCopied] = useClipboard(passcode || '');
  return <Wrapper>
      <BareButton ref={ref}>
        <FlexContainerBlue>
          {isCopied ? <CheckIcon /> : <CopyIcon />}
          <IndentedSpan>{isCopied ? 'Copied' : 'Copy'}</IndentedSpan>
        </FlexContainerBlue>
      </BareButton>
    </Wrapper>;
};
export const Checkboxes = ({
  formValues
}) => {
  const {
    share,
    togglePasscode
  } = useContext(ShareContext);
  const {
    passcode: videoPasscode
  } = share;
  const handleClickEnablePasscode = e => {
    e.preventDefault();
    togglePasscode();
  };
  return <>
      <CheckboxField name="include_public_link" label="Include link to video at the bottom of the email" />
      {formValues.include_public_link && <div>
          <CheckboxContainer>
            <CheckboxField name="enable_passcode" label="Restrict access with a passcode" onClick={handleClickEnablePasscode} />
            <ProTip>
              {I18n.t('publisher.meeting_intelligence.share.email_passcode_protip')}
            </ProTip>
          </CheckboxContainer>
          <div>
            <CheckboxContainer>
              <CheckboxField name="exclude_passcode" label="Exclude passcode from email" disabled={share.accessLevel === 'Public'} />
              <ProTip>
                For sensitive or confidential meetings, we recommend
                sharing the passcode separately from the video link.
              </ProTip>
            </CheckboxContainer>
            {formValues.exclude_passcode && share.accessLevel === 'Passcode' && <PasscodeContainer>
                <Span>Passcode: </Span>
                <b>{videoPasscode}</b>
                <CopyButton passcode={videoPasscode} />
              </PasscodeContainer>}
          </div>
        </div>}
    </>;
};

require("./checkboxes.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./checkboxes.js");